import React from 'react';
import FormControl from '@Theme/natucare/components/FormControl/FormControl';
import Icon from '@Theme/natucare/components/Icon/Icon';
import Input from '@Theme/natucare/components/Input/Input';
import Button from '@Theme/natucare/components/Button/Button';
import { calculatorSubscribePropTypes } from './CalculatorSubscribePropTypes';
import * as styles from './CalculatorSubscribe.module.scss';
const CalculatorSubscribe = /*#__PURE__*/React.forwardRef(({
  heading,
  placeholder,
  handleSubmit,
  onChange,
  icon,
  infoMsg,
  errorMsg,
  button
}, ref) => {
  if (!heading || !placeholder) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: styles.root
  }, /*#__PURE__*/React.createElement(Icon, {
    name: icon,
    classname: styles.rootIcon
  }), heading && /*#__PURE__*/React.createElement("div", {
    className: styles.rootHeading
  }, heading), /*#__PURE__*/React.createElement(FormControl, {
    onSubmit: handleSubmit,
    ref: ref,
    classname: styles.rootForm
  }, /*#__PURE__*/React.createElement(Input, {
    classname: styles.rootInput,
    name: "email",
    type: "email",
    onChange: onChange,
    placeholder: placeholder,
    error: errorMsg,
    errorMsg: errorMsg
  }), /*#__PURE__*/React.createElement(Button, Object.assign({}, button, {
    type: "submit",
    variant: "tertiaryDark",
    icon: button === null || button === void 0 ? void 0 : button.icon,
    classname: styles.rootButton
  }))), /*#__PURE__*/React.createElement("div", {
    className: styles.rootInfo,
    dangerouslySetInnerHTML: {
      __html: infoMsg
    }
  }));
});
export default CalculatorSubscribe;